import {IState, IStateParamsService} from 'angular-ui-router';
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import AuthServiceRS from '../authentication/service/AuthServiceRS.rest';
import BenutzerRS from '../core/service/BenutzerRS.rest';
import InspektoratRS from '../core/service/InspektoratRS.rest';
import RoleUtilService from '../core/service/RoleUtilService';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import TSAdresse from '../models/TSAdresse';
import TSInspektorat from '../models/TSInspektorat';
import TSPasswordData from '../models/TSPasswordData';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;

inspektoratverwaltungRun.$inject = ['RouterHelper'];

/* @ngInject */
export function inspektoratverwaltungRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        new SerfInspektoratVerwaltungState(),
        new SerfInspektoratState()
    ];
}

export class SerfInspektoratVerwaltungState implements IState {
    name = 'inspektoratverwaltung';
    template = '<dv-inspektoratverwaltung-view inspektorat="$resolve.inspektoratList"></dv-inspektoratverwaltung-view>';
    url = '/inspektoratverwaltung/';
    resolve = {
        inspektoratList: loadInspektorat,
    };
    params = {};
}

export class SerfInspektoratState implements IState {
    name = 'inspektorat';
    template = '<dv-inspektorat-view inspektorat="$resolve.inspektorat"></dv-inspektorat-view>';
    url = '/inspektorat/:inspektoratId';
    resolve = {
        inspektorat: getInspektorat
    };
    params = {createNew: null, inspektorat: null, inspektoratId: null};
}

export class IInspektoratStateParams implements IStateParamsService {
    createNew: boolean;
    inspektoratId: string;
    inspektorat: TSInspektorat | undefined;
}

export class IInspektoratVerwaltungParams implements IStateParamsService {
    missingVereinbarungInspektorat: Array<TSInspektorat>
}

loadSiteKey.$inject = ['ApplicationPropertyRS'];

export function loadSiteKey(ApplicationPropertyRS: ApplicationPropertyRS): IPromise<string> {
    return ApplicationPropertyRS.getRecaptchaSiteKey();
}

loadInspektorat.$inject = ['InspektoratRS', 'AuthServiceRS', 'BenutzerRS', 'RoleUtilService', '$q'];

export function loadInspektorat(InspektoratRS: InspektoratRS, AuthServiceRS: AuthServiceRS, BenutzerRS: BenutzerRS,
                                  RoleUtilService: RoleUtilService, $q: IQService): IPromise<Array<TSInspektorat>> {
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return InspektoratRS.getAllInspektorat();
    } else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getInspektoratVerwalterRoles())) {
        let principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getInspektoratForBenutzer(principal.id);
        }
    }
    return $q.when([]);

}

getInspektorat.$inject = ['$stateParams', '$q', 'InspektoratRS', '$log'];

let createInspektorat = function () {
    let inspektorat: TSInspektorat = new TSInspektorat();
    inspektorat.adresse = new TSAdresse();
    inspektorat.verwalter = undefined;
    inspektorat.anlaufstellen = [];
    inspektorat.inspektoren = [];
    return inspektorat;
};

export function getInspektorat($stateParams: IInspektoratStateParams, $q: IQService,
                                inspektoratRS: InspektoratRS, log: ILogService): IPromise<TSInspektorat> {
    if ($stateParams) {

        let inspektoratIdParam = $stateParams.inspektoratId;
        let passedInspektorat = $stateParams.inspektorat;
        let createNew = $stateParams.createNew;
        if (createNew) {
            return $q.when(createInspektorat());
        }
        if (passedInspektorat) {
            return $q.when(passedInspektorat);
        }
        if (inspektoratIdParam) {
            return inspektoratRS.findInspektorat(inspektoratIdParam).then((response: TSInspektorat) => {
                if (response !== undefined && response.verwalter !== undefined) {
                    response.verwalter.passwordData = new TSPasswordData(response.verwalter.email);
                    return response;
                } else {
                    return this.$q.when(createInspektorat());
                }
            });
        }
    }

    log.error('Can`t open requested inspektorat. Creating a new inspektorat object' + $stateParams);
    let deferred = $q.defer<TSInspektorat>();
    deferred.resolve(createInspektorat());
    return deferred.promise;
}








// WEBPACK FOOTER //
// ./src/app/inspektoratverwaltung/inspektoratverwaltung.route.ts